// LIST
export const FETCH_GATES = "app/GATE/FETCH_GATES";
export const FETCH_GATES_SUCCESS = "app/GATE/FETCH_GATES_SUCCESS";
export const FETCH_GATES_FAILURE = "app/GATE/FETCH_GATES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/GATE/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/GATE/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/GATE/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_GATE = "app/GATE/ADD_GATE";
export const ADD_GATE_SUCCESS = "app/GATE/ADD_GATE_SUCCESS";
export const ADD_GATE_FAILURE = "app/GATE/ADD_GATE_FAILURE";

// EDIT
export const EDIT_GATE = "app/GATE/EDIT_GATE";
export const EDIT_GATE_SUCCESS = "app/GATE/EDIT_GATE_SUCCESS";
export const EDIT_GATE_FAILURE = "app/GATE/EDIT_GATE_FAILURE";

// DELETE
export const DELETE_GATE = "app/GATE/DELETE_GATE";
export const DELETE_GATE_SUCCESS = "app/GATE/DELETE_GATE_SUCCESS";
export const DELETE_GATE_FAILURE = "app/GATE/DELETE_GATE_FAILURE";

export const GET_BOOK_INFO = "app/GATE/GET_BOOK_INFO";
export const GET_BOOK_INFO_SUCCESS = "app/GATE/GET_BOOK_INFO_SUCCESS";
export const GET_BOOK_INFO_FAILURE = "app/GATE/GET_BOOK_INFO_FAILURE";

export const TOGGLE_INVITE_VISITOR = "app/GATE/TOGGLE_INVITE_VISITOR";

export const INVITE_VISITOR = "app/GATE/INVITE_VISITOR";
export const INVITE_VISITOR_SUCCESS = "app/GATE/INVITE_VISITOR_SUCCESS";
export const INVITE_VISITOR_FAILURE = "app/GATE/INVITE_VISITOR_FAILURE";
